import Service from "./Service";
const baseurl = '/api/recomendacion';

export default {
    index(params={}) {
        return Service.get(`${baseurl}`,{
            params: params
        });
    }
}